import React from "react";
import {
  Col,
  Form,
  Input,
  Row,
  Space,
  Typography,
  Button,
  Checkbox,
  Radio,
} from "antd";

const { Title } = Typography;

export const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const leasingOptions = [
  "Putnička vozila",
  "Laka dostavna vozila do 3,5 tone",
  "Teška teretna vozila preko 3,5 tone",
  "Građevinske mašine",
  "Quad/Motocikli",
];

const AddBrandForm = ({ isAddBrand = false, actions }) => {
  const [form] = Form.useForm();

  const onFinishAddBrand = (values) => {
    const brandData = {
      name: values.brand,
      assetType: values.leasingOption,
      group: values.group,
    };
    actions.addBrand(brandData);
  };

  return (
    <Space direction="vertical" className="p-8 w-full">
      <Title className="text-xl font-bold text-dark-blue ml-10">
        {`${isAddBrand ? "REGISTRACIJA NOVOG BRANDA" : "UREDI BRAND"} `}
      </Title>
      <Form
        initialValues={{
          remember: true,
        }}
        {...layout}
        form={form}
        name="basic"
        onFinish={onFinishAddBrand}
      >
        <Row>
          <Col span={12}>
            <Form.Item
              /*     initialValue={!isAddBrand ? userState.currentBrand : ""} */
              colon={false}
              labelAlign="right"
              label="Naziv branda"
              name="brand"
              className="mb-10"
              rules={[
                {
                  required: true,
                  message: "Unesite naziv branda!",
                },
              ]}
            >
              <Input placeholder="Unesite naziv branda" />
            </Form.Item>

            <Title className="text-dark-blue text-[16px] font-normal ml-10">
              VRSTA LEASING PREDMETA
            </Title>
            <Space className="bg-brand-bg border border-dashed border-brand-border rounded-md pl-8 pt-6 mb-8 ml-10">
              <Form.Item
                name="leasingOption"
                rules={[
                  {
                    required: true,
                    message: "Izaberite leasing predmet!",
                  },
                ]}
              >
                <Checkbox.Group className="gap-2" options={leasingOptions} />
              </Form.Item>
            </Space>
            <Form.Item
              name="group"
              className="ml-10"
              rules={[
                {
                  required: true,
                  message: "Izaberite grupu!",
                },
              ]}
            >
              <Radio.Group>
                <Space direction="vertical">
                  <Radio value={"A"}>GRUPA A</Radio>
                  <Radio value={"B"}>GRUPA B</Radio>
                  <Radio value={"C"}>GRUPA C</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item>
              <Button
                htmlType="submit"
                className="text-sm text-white bg-light-blue font-medium w-[132px] rounded-sm border-light-blue shadow-sm mt-6 ml-10"
              >
                SPREMI
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Space>
  );
};

export default AddBrandForm;
